module.exports = __webpack_public_path__ + "img/metal_al@2x.f43e2ce1.png";